<div class="photo-container mb-3" [ngClass]="{'mobile': isMobileDevice()}">

	<div>
		<label class="custom-photo-upload mb-0">
			<input type="file" accept="images/*" capture="environment" (change)="onFileSelect($event.target.files, true)"
				[formControl]="photoControl">
			<img alt="auto" class="rounded" src="assets/images/photo_upload.png">
		</label>
	</div>

	<ng-container *ngIf="isMobileDevice()">
		<div>
			<label class="custom-photo-upload mb-0">
				<input type="file" accept=".png, .jpg, .jpeg" (change)="onFileSelect($event.target.files, false)" multiple
					[formControl]="photoControl">
				<img alt="auto" class="upload-gallery rounded" src="assets/images/upload-gallery.svg">
			</label>
		</div>
	</ng-container>

	<div>
		<carousel [cellsToShow]="photoService.photoCarousel.length" [freeScroll]="true" [height]="60" objectFit="contain" [arrows]="false">
			<div class="carousel-cell" *ngFor="let photo of photoService.photoCarousel">
				<img [src]="photo.src" (click)="showPhoto(photo)">
				<span class="icon xs icon-delete" (click)="deletePhoto(photo)" *ngIf="user.hasFullAccess">
					<fa-icon [icon]="['fas', 'times']" size="xs"></fa-icon>
				</span>
			</div>
		</carousel>
	</div>
</div>
